import moment from "moment";
import get from "lodash";

export const dateTime = (d, format) => {
	if (!d)
		return "";
	if (!format)
		format = "MMM DD, Y [at] hh:mma";
	return moment(d * 1000).format(format);
}

export const number = (d) => {
	const number = d ? d : 0;
	return parseInt(number).toLocaleString();
}

export const todayDateInUnix = () => {
	return Math.floor(moment.unix(moment()).valueOf() / 1000000);
}

export const timeDisplay = (time, format) => {
	if (!time || parseInt(time) === 0) {
		return "-";
	}
	var hr = Math.floor(time / 3600);
	var min = Math.floor(time % 3600 / 60);
	var sec = Math.floor(time % 3600 % 60);

	if (hr <= 0 && min <= 0) {
		return sec + " secs";
	}
	let str = "";
	if (format === "hh:mm") {
		str += hr < 10 ? "0" + hr : hr;
		str += ":";
		str += min < 10 ? "0" + min : min;
	}
	else {
		if (hr > 0)
			str += hr.toString() + ((hr > 1) ? " hrs " : " hr ");
		if (min > 0)
			str += min.toString() + ((min > 1) ? " mins" : " min");
	}
	return str;
}

export const formatDate = (date = 0) => {
	const parseDate = date !== '' && date !== 0 ? moment(date * 1000).toDate() : new Date();
	const month = {
		"short": parseDate.toLocaleString("en-GB", { month: 'short' }),
		"long": parseDate.toLocaleString("en-GB", { month: 'long' })
	};
	return `${parseDate.getDate()} ${month["short"]}, ${parseDate.getFullYear()}`;
}

export const formatDateTime = (d, format = "DD/MM/YYYY HH:mm:ss") => {
	if (d === "" || d === "0001-01-01T00:00:00" || d === "0001-01-01T00:00:00Z" || !d) {
		return "";
	}
	if (d === "now") {
		return moment(new Date()).local().format(format);
	}
	return moment(d).local().format(format);
}


export function time() {
	return Math.floor(new Date().getTime() / 1000);
}

export const getCurrencySymbol = (currency = "GBP") => {
    const currencies = {
        "GBP": "£",
    }
    return get(currencies, currency);
}

